import { Controller } from "@hotwired/stimulus"

/**
 * Instructions Toggle Controller
 * 
 * Manages instructions toggle functionality.
 * Shows/hides form content when instructions are toggled.
 * 
 * Usage: 
 *   Add data-controller="instructions-toggle" to the container
 *   Add data-instructions-toggle-target="collapse" to the instructions element
 *   Add data-instructions-toggle-target="helpText" to the help text element
 *   Add data-instructions-toggle-target="formContent" to the form content element
 */
export default class extends Controller {
  static targets = ["collapse", "helpText", "formContent"]
  
  connect() {
    // Find elements - prefer targets, fallback to ID-based lookup
    this.collapseEl = this.hasCollapseTarget ? this.collapseTarget : this.element.querySelector('[id*="-instructions"]')
    this.helpTextEl = this.hasHelpTextTarget ? this.helpTextTarget : this.element.querySelector('[id*="help-text"]')
    this.formContentEl = this.hasFormContentTarget ? this.formContentTarget : this.element.querySelector('[id*="form-content"]')
    
    // Find the toggle button
    const toggleButton = this.element.querySelector('[data-bs-target]')
    if (toggleButton) {
      // Remove Bootstrap's collapse behavior
      toggleButton.removeAttribute('data-bs-toggle')
      toggleButton.removeAttribute('data-bs-target')
      
      // Add our own click handler
      this.boundToggle = this.toggle.bind(this)
      toggleButton.addEventListener('click', this.boundToggle)
    }
    
    // Set initial state - form should be visible, instructions hidden
    if (this.helpTextEl) {
      this.helpTextEl.textContent = 'Instructions'
    }
    if (this.formContentEl) {
      this.formContentEl.style.display = 'block'
    }
    if (this.collapseEl) {
      this.collapseEl.style.display = 'none'
    }
  }
  
  disconnect() {
    // Remove event listeners
    const toggleButton = this.element.querySelector('button[data-controller*="instructions-toggle"], button[id*="help"]')
    if (toggleButton && this.boundToggle) {
      toggleButton.removeEventListener('click', this.boundToggle)
    }
  }
  
  toggle(event) {
    if (event) {
      event.preventDefault()
    }
    
    const showingInstructions = this.collapseEl && this.collapseEl.style.display !== 'none'
    
    if (showingInstructions) {
      // Hide instructions, show form
      if (this.collapseEl) {
        this.collapseEl.style.display = 'none'
      }
      if (this.formContentEl) {
        this.formContentEl.style.display = 'block'
      }
      if (this.helpTextEl) {
        this.helpTextEl.textContent = 'Instructions'
      }
    } else {
      // Show instructions, hide form
      if (this.collapseEl) {
        this.collapseEl.style.display = 'block'
      }
      if (this.formContentEl) {
        this.formContentEl.style.display = 'none'
      }
      if (this.helpTextEl) {
        this.helpTextEl.textContent = 'Hide instructions'
      }
    }
  }
}
